import { Component } from '@angular/core';

@Component({
  selector: 'recrewt-footer-only-layout',
  templateUrl: './footer-only-layout.component.html',
  styleUrls: ['./footer-only-layout.component.scss'],
  standalone: false,
})
export class FooterOnlyLayoutComponent {}
